import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../../Common/Loader";
import SystemModal from "../../Common/SystemModal";
import ajaxStudent from "../../../util/remote/ajaxStudent";


const ConfirmAddStudent=(props)=>{

    const [loading, setLoading] = useState(false)
    const studentName = props.studentName
    
    const handleAdd = async(e) =>{
        e.preventDefault()
        var data = {
            first_name: props.firstName,
            surname: props.lastName,
            gender: props.gender,
            school_code: props.schoolCode,
            reg_no: props.regNo,
            authum_student_id: props.authumID,
            class_name: props.className
        };
        setLoading(true)
        const server_response = await ajaxStudent.createAuthumStudent(data);
        setLoading(false);
        if(server_response.status==="OK"){
            toast.success(server_response.message);
            props.g()
        }
        else{
            toast.error(server_response.message); 
        } 
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                    <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                    <button 
                        type="button" 
                        className={`btn-fill-md text-light bg-dodger-blue`} 
                        onClick={handleAdd}>Confirm<i class="fas fa-check mg-l-15"></i></button>
                    </>
        }
    }

    return(
        <SystemModal
            title="Confirm Student Registration"
            id="model-student-register"
            size="md"
            footer={RenderFooter}
        >

        <div className="row">
        <div className="bg-white">
                <div className="alert text-center">
                    <i className="fe fe-alert-circle fs-50 text-success" style={{fontSize:"50px"}}></i>
                    <h3 className="mt-2 mb-1">Are you sure you want to register {studentName} into Buzztime?</h3>
                    <p className="mb-3 mb-3 tx-inverse">{studentName} will be registered as a new student.</p>
                </div>
            </div>
        </div>
       
        </SystemModal>
    )
}

export default ConfirmAddStudent
